module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-process"
  }, [((!_vm.info.procs || _vm.info.procs.length === 0) && !_vm.loading) ? _c('div', {
    staticClass: "no-process"
  }, [_vm._v("\n    暂时没有审批进程\n  ")]) : _vm._e(), _vm._v(" "), (_vm.info.procs && _vm.info.procs.length !== 0) ? _c('ul', {
    staticClass: "process-list"
  }, _vm._l((_vm.info.procs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(item.step))]), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.finishTime))]), _vm._v(" "), _c('span', {
      staticClass: "top"
    }), _vm._v(" "), _c('span', {
      staticClass: "bottom"
    }), _vm._v(" "), _c('span', {
      staticClass: "circle"
    })])
  })) : _vm._e(), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4da1c92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-process.vue
// module id = 374
// module chunks = 1